import { useState } from 'react';

import Box from '@mui/material/Box';
import { Container } from '@mui/material';

import { usePathname } from 'src/routes/hooks';
import { isMessagesPath } from 'src/routes/paths';

import Logo from 'src/components/logo';

import Nav from './nav';

// ----------------------------------------------------------------------

type Props = {
  children?: React.ReactNode;
};

export function NoNavLayout({ children }: Props) {
  return (
    <Container sx={{ p: 0 }}>
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          p: { xs: 1, md: 2 },
          zIndex: 1000, // Ensure it stays on top of other content
        }}
      >
        <Logo
          sx={{
            ml: { xs: 1, md: 2 },
          }}
        />
        <Box
          sx={{
            mr: { xs: 1, md: 2 },
          }}
        >
          {/* <LanguagePopover /> */}
        </Box>
      </Box>

      <Container sx={{ height: '100%', p: 0 }}>{children}</Container>
    </Container>
  );
}

export function AppLayout({ children }: Props) {
  const [openNav, setOpenNav] = useState(false);
  const pathname = usePathname();
  const showNav = !isMessagesPath(pathname);

  return (
    <Box
      sx={{
        minHeight: 1,
        display: 'flex',
        maxHeight: '100vh',
        flexDirection: { xs: 'column', lg: 'row' },
      }}
    >
      {showNav ? <Nav openNav={openNav} setOpenNav={setOpenNav} /> : null}

      <Container sx={{ p: 0, flex: 1 }}>{children}</Container>
    </Box>
  );
}
